import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_035",
  "use": "icon-su_035-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-su_035\"><defs><style>#icon-su_035 .cls-1{fill:#777;}</style></defs><g id=\"icon-su_035_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_035_icon\"><polygon class=\"cls-1\" points=\"3 6 4 8 5 6 3 6\" /><polygon class=\"cls-1\" points=\"7 2 8 0 0 0 1 2 7 2\" /><polygon class=\"cls-1\" points=\"5.5 5 6.5 3 1.5 3 2.5 5 5.5 5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol